module.exports = __webpack_public_path__ + "static/img/bg-fr.c831fc21.png";